<template>
  <div class="aq-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1>首页</h1>
    </div>

    <div class="content-area">
         <!-- 任务信息显示区域 -->
        <div v-if="taskInfo" class="task-info-section">
          <div class="task-info">
            <h3>任务信息</h3>
            <!-- 二维码图片 -->
            <div class="qrcode-section">
              <img :src="taskInfo.qrCodeUrl || defaultQrCode" alt="二维码" class="qrcode-img" />
            </div>

            <!-- 过期时间 -->
            <div class="expire-time">
              <p class="expire-text">交单截止时间: {{ formatDate(taskInfo.expireTime) }}</p>
            </div>
          </div>

          <!-- 任务信息提交表单 -->
          <div class="submit-form-section">

            <div class="form-item">
              <label>提交姓名<span class="ftip">(姓名和照片至少填写一项)</span></label>
              <van-field
                v-model="submitForm.name"
                placeholder="请输入姓名"
                class="name-input"
              />
            </div>
            <div class="form-item">
              <label>上传交单照片<span class="ftip">(姓名和照片至少填写一项)</span></label>
              <div class="upload-section">
                <div class="upload-area" @click="selectFile">
                  <div class="upload-icon">📷</div>
                </div>
                <input
                  type="file"
                  ref="fileInput"
                  @change="handleFileChange"
                  style="display: none;"
                  accept="image/*"
                />
                <div v-if="submitForm.imageUrl" class="image-preview">
                  <img :src="submitForm.imageUrl" alt="预览图" class="preview-img" />
                </div>
                <div  v-if="!submitForm.imageUrl" class="image-preview">
                  <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2Kw0hlFU.png" alt="预览图" class="preview-img" />
                </div>

              </div>
            </div>
            <div class="form-item">
              <label><span class="ftip">示例：蚂蚁阿福左上角三个横杠-设置-实名认证-支付宝一键导入</span></label>
            </div>
            <div class="form-item">
              <van-button
                type="primary"
                @click="submitOrder"
                :loading="submittingOrder"
                :disabled="!canSubmitOrder"
                class="submit-order-btn"
              >
                {{ submittingOrder ? '提交中...' : '提交订单' }}
              </van-button>
            </div>
          </div>
        </div>

        <!-- 申请做单按钮 - 仅在没有任务信息时显示 -->
        <div v-if="!taskInfo" class="apply-section">
          <van-button
            type="default"
            size="large"
            @click="applyTask"
            :loading="submitting"
            :disabled="submitting"
            class="apply-btn"
          >
            {{ submitting ? '提交中...' : '申请做单' }}
          </van-button>
        </div>

        <!-- 显示提交结果 -->
        <div v-if="orderId" >

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { applyTask as applyTaskApi, queryTask as queryTaskApi, uploadImage as uploadImageApi, submitOrder as submitOrderApi } from '@/api/aq'

export default {
  name: 'AqIndex',
  data() {
    return {
      traderId: null,
      submitting: false,
      orderId: null,
      taskInfo: null,
      defaultQrCode: 'https://example.com/default-qr-code.png',
      remainingTimeStr: '',
      countdownInterval: null,
      submitForm: {
        name: '',
        imageUrl: ''
      },
      submittingOrder: false
    }
  },
  created() {
    // 从路由参数获取traderId
    this.traderId = this.$route.query.traderId || this.$route.params.traderId || this.$route.query.tradeId || this.$route.params.tradeId
    console.log('AqIndex created, traderId:', this.traderId)

    // 页面加载时查询任务信息
    if (this.traderId) {
      console.log('开始查询任务信息，traderId:', this.traderId)
      this.loadTaskInfo()
    } else {
      console.log('未获取到traderId参数')
    }
  },
  methods: {
    async applyTask() {
      if (!this.traderId) {
        this.$toast('缺少traderId参数')
        return
      }

      this.submitting = true
      try {
        const response = await applyTaskApi(this.traderId)

        // 假设API返回格式为 { orderId: "xxx" } 或直接返回订单ID
        this.orderId = response.orderId || (response.data && response.data.orderId) || response
        this.$toast('申请成功')
        this.loadTaskInfo()
        console.log('申请任务成功，订单ID:', this.orderId)
      } catch (error) {
        console.error('申请任务失败:', error)
        this.$toast('申请失败: ' + (error.message || '未知错误'))
      } finally {
        this.submitting = false
      }
    },
    async loadTaskInfo() {
      console.log('loadTaskInfo方法被调用，traderId:', this.traderId)
      try {
        const response = await queryTaskApi(this.traderId)
        console.log('查询任务信息成功，响应:', response)

        if (response && response.data && response.code === '200') {
          // 处理返回的数据格式
          const taskData = response.data
          console.log('任务数据111:', taskData)
          this.taskInfo = {
            traderId: taskData.trader_id,
            expireTime: taskData.expiretime, // Unix时间戳（秒）
            qrCodeUrl: taskData.qrcode,
            orderId: taskData.order_id,
            status: taskData.status
          }

          console.log('任务信息已设置:', this.taskInfo)
        }
      } catch (error) {
        console.error('查询任务信息失败:', error)
        console.log('错误详情:', error.response || error.message)
      }
    },

    // 格式化时间戳为日期字符串
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000) // 时间戳是秒，需要乘以1000
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    selectFile() {
      this.$refs.fileInput.click()
    },

    handleFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        // 上传图片
        this.uploadImage(file)
      }
    },

    async uploadImage(file) {
      try {
        const response = await uploadImageApi(file)
        if (response && response.data && response.code === '200') {
          // 更新图片URL
          this.submitForm.imageUrl = response.data.imageUrl || response.data
          this.$toast('上传成功')
          console.log('图片上传成功，URL:', this.submitForm.imageUrl)
        } else {
          this.$toast('上传失败')
        }
      } catch (error) {
        console.error('上传图片失败:', error)
        this.$toast('上传失败: ' + (error.message || '未知错误'))
      }
    },

    async submitOrder() {
      if (!this.submitForm.name || !this.submitForm.imageUrl) {
        this.$toast('请填写姓名并上传交单照片')
        return
      }

      this.submittingOrder = true
      try {
        // 获取当前任务的订单ID
        const orderId = this.taskInfo.orderId

        // 调用提交订单接口
        const response = await submitOrderApi(orderId, this.submitForm.name, this.submitForm.imageUrl)

        if (response && response.code === '200') {
          this.$toast('提交成功')
          //this.loadTaskInfo()
          this.taskInfo=null;
          console.log('提交订单成功，响应:', response)
          // 可以在这里重置表单
          this.submitForm = {
            name: '',
            imageUrl: ''
          }
        } else {
          this.$toast('提交失败')
        }
      } catch (error) {
        console.error('提交订单失败:', error)
        this.$toast('提交失败: ' + (error.message || '未知错误'))
      } finally {
        this.submittingOrder = false
      }
    }
  },
  computed: {
    canSubmitOrder() {
      return this.submitForm.name && this.submitForm.imageUrl
    }
  }
}
</script>

<style scoped>
.image-preview-tip{
  position: absolute;
  right: 10px;
  top: 0px;
  width: 300px;
}
.aq-container {
  padding: 16px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 50px); /* 减去tabbar的高度 */
}

.page-header {
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  text-align: center;
}

.page-header h1 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.content-area {
  background-color: white;
  padding: 16px;
  border-radius: 8px;
}

.home-content {
  margin-top: 16px;
}

.apply-section {
  margin: 20px 0;
}

.apply-btn {
  border-radius: 25px !important; /* 圆角 */
  background-color: #1989fa !important; /* 蓝色背景 */
  border-color: #1989fa !important; /* 蓝色边框 */
  color: white !important; /* 白色文字 */
  border-radius: 25px !important;
}

.apply-btn[disabled] {
  background-color: #cccccc !important; /* 禁用时的灰色 */
  border-color: #cccccc !important;
}

.result-section {
  margin-top: 20px;
  padding: 10px;
  background-color: #f0f9eb;
  border-radius: 4px;
  border-left: 4px solid #67c23a;
}

.success-text {
  color: #67c23a;
  margin: 0;
  font-weight: bold;
}

.task-info-section {
  margin-top: 20px;
}

.task-info {
  background-color: white;
  padding: 16px;
  border-radius: 8px;
}

.task-info h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #333;
}

.qrcode-section {
  text-align: center;
}

.qrcode-img {
  width: 100%;
  max-width: 200px; /* 限制最大宽度，避免图片过大 */
  height: auto;
}

.expire-time {
  margin-top: 10px;
}

.expire-text {
  color: red;
  font-weight: bold;
  margin: 0;
  font-size: 14px;
  text-align: center;
}

.submit-form-section {
  margin-top: 20px;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
}

.submit-form-section h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 16px;
  color: #333;
}

.form-item {
  margin-bottom: 15px;
}

.form-item label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #666;
}

.name-input {
  width: 100%;
}

.upload-section {
  display: flex;
  align-items: center;
  gap: 15px;
  position: relative;
}

.upload-area {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.upload-icon {
  font-size: 18px;
  margin-right: 5px;
}

.upload-text {
  font-size: 14px;
  color: #666;
}

.image-preview {
  flex: 1;
  max-width: 100px;
  max-height: 100px;
}

.preview-img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
  border: 1px solid #ddd;
  object-fit: cover;
}

.submit-order-btn {
  width: 100%;
  margin-top: 10px;
  border-radius: 25px !important; /* 圆角 */
  background-color: #1989fa !important; /* 蓝色背景 */
  border-color: #1989fa !important; /* 蓝色边框 */
  color: white !important; /* 白色文字 */
}
.ftip{
  color: #999;
  font-size: 14px;
}

</style>
